import React, { useEffect } from 'react'

import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../../common/button'
import AnalyticalThings, { IAnalyticalThingProps, AnalyticalThingsProps } from './analytical-things'

import CTARecipeArrow from '../../../../images/recipe_cta_arrow.svg'

import './recipe.css'
import CdnImage from 'components/util/CdnImage'

interface IIngredientItem {
  ingredientImage: any
  ingredientName: string
  ingredientDescription: string
}

export interface IRecipeIngredientProps {
  backgroundColor: string
  mainDescription: string
  mainDescriptionColor: string
  subDescription: string
  subDescriptionColor: string
  dogImage: string
  dogImageBackgroundColor: string
  ingredientItems: IIngredientItem[]
  recipeIngredientImg: any
  analyticalThings: IAnalyticalThingProps
  CTATitle: string
  CTAButton: LinkButtonProp
}

const RecipeIngredient = ({
  backgroundColor,
  mainDescription,
  mainDescriptionColor,
  subDescription,
  subDescriptionColor,
  dogImage,
  dogImageBackgroundColor,
  ingredientItems,
  recipeIngredientImg,
  analyticalThings,
  CTATitle,
  CTAButton
}: IRecipeIngredientProps) => {
  useEffect(() => {
    const element = document.getElementById('ingredients-cta-button-title')
    const elementParentWidth = element?.parentElement?.clientWidth
    const ingredientCTAButtonHolder = document.getElementsByClassName('ingredient-cta-button')[0]
    if (element?.clientWidth && elementParentWidth) {
      element.style.left = `${(elementParentWidth - element?.clientWidth - 50) / 2}px`
    }
    if (ingredientCTAButtonHolder?.clientWidth && ingredientCTAButtonHolder?.parentElement?.clientWidth) {
      ingredientCTAButtonHolder.style.left = `${
        (ingredientCTAButtonHolder?.parentElement?.clientWidth - ingredientCTAButtonHolder?.clientWidth) / 2
      }px`
    }
  }, [CTATitle])

  const getIngredientItems = () => {
    if (!ingredientItems) ingredientItems = []

    return ingredientItems.map((item: IIngredientItem, i: number) => {
      return (
        <div className="ingredient-item mb-4 flex w-full" key={`${item.ingredientName}-${i}`}>
          <div className="mr-4 w-2/12 p-2 sm:w-1/12">
            <img src={item.ingredientImage} alt={item.ingredientName} className="w-full object-contain" />
          </div>
          <div className="flex w-10/12 flex-col justify-center sm:w-11/12">
            <p className="ingredient-item-text text-sm sm:text-base">
              <strong>{item.ingredientName}</strong> - {item.ingredientDescription}
            </p>
          </div>
        </div>
      )
    })
  }

  analyticalThings = analyticalThings || {}
  CTAButton = CTAButton || {}
  return (
    <div className="w-full" style={{ backgroundColor }}>
      <div className="container relative mx-auto w-full">
        {/* desktop */}
        <div className="hidden sm:flex">
          <div className="w-2/3 p-4">
            <h2 style={{ color: mainDescriptionColor }} className="py-6 text-xl sm:text-3xl">
              {mainDescription}
            </h2>
            <h5 style={{ color: subDescriptionColor }} className="text-base sm:text-xl">
              {subDescription}
            </h5>
            <div className="ingredient-container w-full p-4 sm:w-2/3">{getIngredientItems()}</div>
          </div>
          <div className="relative w-1/3">
            <div className="ingredient-dog-pic-wrap" style={{ backgroundColor: dogImageBackgroundColor }}>
              <CdnImage className="ingredient-dog-pic" url={dogImage} />
            </div>
          </div>
        </div>
        <div className="hidden w-full sm:flex">
          <div className="analytical-container w-1/2">
            <AnalyticalThings
              analytical={analyticalThings.analytical}
              nutritional={analyticalThings.nutritional}
              backgroundColor={analyticalThings.backgroundColor}
              allergenTitle={analyticalThings.allergenTitle}
              allergenDescription={analyticalThings.allergenDescription}
            />
          </div>
          <div className="ingredient-img-container w-1/2">
            {/* desktop ingredient image */}
            <div className="recipe-ingredient-img-wrap-desktop">
              <CdnImage url={recipeIngredientImg} className="w-full object-contain" />
            </div>
          </div>
        </div>

        {/* mobile */}
        <div className="flex sm:hidden">
          <div className="mobile-ingredient-main-des p-4">
            <h2 style={{ color: mainDescriptionColor }} className="h2 py-6 text-lg">
              {mainDescription}
            </h2>
          </div>
          <div className="mobile-ingredient-right-img relative">
            <div className="ingredient-dog-pic-wrap" style={{ backgroundColor: dogImageBackgroundColor }}>
              <img src={dogImage} className="ingredient-dog-pic" />
            </div>
          </div>
        </div>
        {/* mobile */}
        <div className="block p-4 sm:hidden">
          <h5 style={{ color: subDescriptionColor }} className="mobile-ingredients-sub-desc">
            {subDescription}
          </h5>
        </div>

        {/* mobile */}
        <div className="ingredient-container block w-full p-4 sm:mb-48 sm:hidden sm:w-2/3">{getIngredientItems()}</div>

        {/* mobile ingredient image */}
        <div className="recipe-ingredient-img-wrap mx-auto block w-11/12 sm:hidden">
          <img src={recipeIngredientImg} className="w-full object-contain" />
        </div>

        {/* mobile */}
        <div className="block w-11/12 sm:hidden sm:w-2/3">
          <AnalyticalThings
            analytical={analyticalThings.analytical}
            nutritional={analyticalThings.nutritional}
            backgroundColor={analyticalThings.backgroundColor}
            allergenTitle={analyticalThings.allergenTitle}
            allergenDescription={analyticalThings.allergenDescription}
          />
        </div>

        <div className="ingredients-cta-button relative pt-12">
          <div className="ingredients-cta-button-title relative h-12">
            <h2 className="absolute text-primary" id="ingredients-cta-button-title">
              {CTATitle}
              <img className="absolute" src={CTARecipeArrow} />
            </h2>
          </div>
          <div className="h-16">
            <LinkButton
              buttonColor={CTAButton.buttonColor}
              buttonText={CTAButton.buttonText}
              buttonTextColor={CTAButton.buttonTextColor}
              loggedInButtonText={CTAButton.loggedInButtonText}
              buttonUrl={CTAButton.buttonUrl}
              isLink={CTAButton.isLink}
              classList={
                'ingredient-cta-button absolute block w-4/5 py-3 px-5 text-center bg-white border border-transparent rounded-full shadow-md text-base font-medium text-indigo-700 hover:bg-gray-50 sm:inline-block sm:w-72'
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecipeIngredient

export const RecipeIngredientProps = {
  name: 'recipeIngredient',
  type: 'object',
  defaultValue: {
    backgroundColor: '#004355',
    mainDescription: 'Main Description',
    mainDescriptionColor: 'black',
    subDescription: 'Sub Description',
    subDescriptionColor: 'black',
    dogImage: null,
    dogImageBackgroundColor: 'pink',
    ingredientItems: [],
    recipeIngredientImg: null
  },
  subFields: [
    { name: 'backgroundColor', type: 'color', defaultValue: '#004355' },
    { name: 'mainDescription', type: 'string', defaultValue: 'Main Description' },
    { name: 'mainDescriptionColor', type: 'color', defaultValue: 'black' },
    { name: 'subDescription', type: 'string', defaultValue: 'Sub Description' },
    { name: 'subDescriptionColor', type: 'color', defaultValue: 'black' },
    { name: 'dogImage', type: 'file', defaultValue: null },
    { name: 'dogImageBackgroundColor', type: 'color', defaultValue: 'pink' },
    {
      name: 'ingredientItems',
      type: 'list',
      defaultValue: [
        {
          ingredientImage: null,
          ingredientName: 'ingredientName',
          ingredientDescription:
            'Our British Beef is locally sourced and packed full of digestible protein Spinach - This superfood is full of iron, vitamins A, B, C and K as well as Antioxidants. Apple - Excellent source of Vitamin A & C plus dietary fibre to improve gut health. Chia Seeds'
        }
      ],
      subFields: [
        { name: 'ingredientImage', type: 'file', defaultValue: null },
        { name: 'ingredientName', type: 'text', defaultValue: 'Beef' },
        {
          name: 'ingredientDescription',
          type: 'text',
          defaultValue:
            'Our British Beef is locally sourced and packed full of digestible protein Spinach - This superfood is full of iron, vitamins A, B, C and K as well as Antioxidants. Apple - Excellent source of Vitamin A & C plus dietary fibre to improve gut health. Chia Seeds'
        }
      ]
    },
    {
      ...AnalyticalThingsProps
    },
    {
      name: 'recipeIngredientImg',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'CTATitle',
      type: 'string',
      defaultValue: 'Like this recipe?'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'CTAButton'
    }
  ]
}
